enum LoginMultifactorAuthenticationFlowStepEnum {
    LoginMultifactorAuthenticationStep,
    LoginMultifactorAuthenticationIsMandatoryStep,
    LoginMultifactorAuthenticationSetupStep
}

export { LoginMultifactorAuthenticationFlowStepEnum };
